const es = {
  unique_death_history: "Registro de muertes",
  reg_events: "Eventos",
  reg_details: "Descripción y recompensas",
  reg_details_pending: "Los detalles se anunciarán pronto.",
  reg_open: "Abierto",
  reg_closed: "Cerrado",
  reg_joined: "Inscrito",
  reg_equalized: "Equalizado",
  reg_standard: "Normal",
  reg_cancel_registration: "Cancelar inscripción",
  reg_joined_hint: "Ya estás inscrito en este evento.",
  reg_open_hint: "Inscripciones abiertas. Pulsa Register para participar.",
  reg_closed_hint: "Las inscripciones están cerradas.",
  reg_translating: "Traduciendo…",
  reg_translation_error: "No se pudo traducir. Se muestra el texto original.",
  reg_retry: "Reintentar",

  battle_pass: 'Pase de Batalla',
  menu_main: 'Menú principal',
  menu_tools: 'Herramientas',
  menu_open: 'Abrir menú',
  menu_close: 'Cerrar menú',
  menu_home: 'Volver al inicio',
  guide: 'Guía',
  daily_login: 'Login diario',
  spin_title: 'Ruleta',
  special_offer: 'Oferta especial',
  auction_system: 'Casa de subastas',
  title_manager: 'Personalización',
  ranking: 'Ranking',
  unique: 'Únicos',
  job_system: 'Sistema de Trabajo',
  vip_system: 'VIP',
  donation: 'Donación',
  surveys: 'Encuestas',
  settings: 'Configuración',
  messages: 'Mensajes',
  unique_status_title: 'Estado actual',
  unique_logs_title: 'Historial',
  unique_table_name: 'Único',
  unique_table_character: 'Personaje',
  unique_table_status: 'Estado',
  unique_table_event: 'Evento',
  unique_table_map: 'Mapa',
  unique_table_time: 'Tiempo',
  unique_status_alive: 'Vivo',
  unique_status_dead: 'Muerto',
  unique_event_spawn: 'Spawn',
  unique_event_death: 'Kill',
  unique_refresh: 'Recargar',
  unique_sort_alive_first: 'Ordenar: vivos primero',
  unique_sort_dead_first: 'Ordenar: muertos primero',
  unique_deaths_tooltip_title: 'Últimos 5 kills',
  unique_deaths_empty: 'Sin kills registrados',
  unique_load_error: 'No se pudo cargar el historial de únicos.',
  unique_no_data: 'No se encontraron datos.',
  unique_logs_empty: 'Aún no hay eventos en el historial.',
  schedule: 'Horario',
  sched_no_events: 'No hay eventos programados.',
  sched_running: 'EN CURSO',
  sched_load_error: 'No se pudo cargar el horario. Intenta más tarde.',
  reg_register: 'Registrar',
  reg_remove_register: 'Remover registro',
  reg_processing: 'Procesando...',
  reg_registered_success: 'Te has registrado al evento correctamente',
  reg_unregistered_success: 'Te has desregistrado del evento correctamente',
  reg_no_events: 'No hay eventos disponibles.',
  reg_load_error: 'No se pudieron cargar los eventos. Intenta más tarde.',
  reg_error_invalid_event: 'Evento inválido',
  reg_error_not_logged_in: 'Debes estar logueado para registrar eventos',
  reg_error_not_available: 'El evento no está disponible para registro',
  reg_error_already_registered: 'Error al registrarse al evento. Puede que ya estés registrado.',
  reg_error_unregister: 'Error al desregistrarse del evento',
  reg_error_processing: 'Error al procesar la solicitud',
  reg_error_connection: 'Error de conexión. Por favor, intenta nuevamente.',
  reg_modal_title: 'Equalized System',
  reg_weapons: 'Armas (Selecciona 1)',
  reg_buffs: 'Buffs (Selecciona 1)',
  reg_essence: 'Essence (Siempre activo)',
  reg_force: 'Force (Siempre activo)',
  reg_btn_register: 'Registrar',
  reg_btn_cancel: 'Cancelar',
  register: 'Registro',
  r_ia: 'R-AI',
  chat_welcome_message: '¡Hola! 👋 Soy <strong>R-AI</strong>, tu asistente de IA para Silkroad Origins.',
  chat_welcome_question: '¿En qué puedo ayudarte hoy?',
  chat_input_placeholder: 'Escribe tu mensaje...',
  chat_send_button: 'Enviar',
  chat_send_title: 'Enviar mensaje',
  chat_char_count: '{current} / {max}',
  chat_load_error: 'No se pudo cargar el historial del chat. Intenta más tarde.',
  chat_error_connection: 'Error de conexión. Por favor, intenta nuevamente.',
  drop_log: 'Drop Log',
  log_table_item: 'Ítem',
  log_table_character: 'Personaje',
  log_table_monster: 'Monstruo',
  log_table_map: 'Mapa',
  log_table_date: 'Fecha',
  log_table_ago: 'Hace',
  log_search_placeholder: 'Buscar...',
  log_time_seconds: 'seg',
  log_time_minutes: 'min',
  log_time_hours: 'h',
  log_time_days: 'd',
  log_filter_race: 'Raza',
  log_filter_race_chinese: 'Chino',
  log_filter_race_euro: 'Europeo',
  log_filter_type: 'Tipo',
  log_filter_time_all: 'Todos',
  log_filter_time_today: 'Hoy',
  log_filter_time_week: 'Esta Semana',
  log_filter_time_month: 'Este Mes',
  log_filter_apply: 'Aplicar',
  log_filter_reset: 'Limpiar',
  log_load_error: 'No se pudo cargar el drop log. Intenta más tarde.',
  log_no_results: 'No hay drops que coincidan con los filtros.',
  log_modal_i_need_it: 'Lo necesito',
  log_modal_sending: 'Enviando...',
  log_modal_sent: 'Enviado',
  log_modal_error: 'Error',
  log_modal_connection_error: 'Error de conexión',
  log_modal_message_template: 'Hola, me interesa el {item} que droppeaste. ¿Cuánto pides?',
  log_chat_button_title: 'Contactar por chat',
  log_chat_self_error: 'No puedes enviarte mensajes a ti mismo',
  languages: 'Idiomas',
  server_time: 'Hora del servidor',
  loading_data: 'Cargando datos...',
  auth_loading: 'Autenticando...',
  auth_error: 'No se pudo autenticar. Reabre desde el juego.',
  bp_duration: 'Duración: {start} - {end} ({remaining} restantes)',
  bp_days_remaining: '{days} DÍAS RESTANTES',
  bp_day_remaining: '1 DÍA RESTANTE',
  bp_level: 'Nivel',
  bp_level_hero: 'NIVEL {level}',
  bp_levelup_cta: 'SUBIR DE NIVEL',
  bp_season: 'TEMPORADA {id}',
  bp_buy_pass: 'Comprar Pase',
  bp_unlock_premium: 'Desbloquear Pase Premium',
  bp_premium_active: 'Pase premium activo',
  bp_premium_reward: 'Recompensa Premium',
  bp_track_premium: 'Premium',
  bp_track_free: 'Free',
  bp_max_level: 'Nivel Máximo: {level}',
  bp_preview_level_btn: 'NIVEL {level}',
  bp_no_active: 'Sin battle pass activo',
  bp_reward_success: '¡Recompensa reclamada con éxito!',
  bp_claim_error: 'Error al reclamar. Inténtalo más tarde.',
  bp_exp_info_title: 'Experiencia del Pase de Batalla',
  bp_exp_tower_defense_victory: 'Tower Defense: Victoria: 45 puntos | Derrota: 5 puntos',
  bp_exp_hell_prison_victory: 'Prisión Infernal: Victoria: 50 puntos | Derrota: 10 puntos',
  bp_exp_witch_hunt_victory: 'Caza de Brujas: Victoria: 50 puntos | Derrota: 10 puntos',
  bp_exp_survival: 'Supervivencia: 1er Lugar: 30 Puntos | 2do Lugar: 15 puntos | 3er Lugar: 5 puntos',
  bp_exp_last_man_standing: 'Último en Pie: Victoria: 95 puntos',
  bp_exp_madness: 'Locura: 1er Lugar: 30 Puntos | 2do Lugar: 15 puntos | 3er Lugar: 5 puntos',
  bp_exp_garden_job_victory: 'Jardín (Trabajo): Victoria: 50 puntos | Derrota: 10 puntos',
  bp_exp_capture_flag_victory: 'Captura la Bandera: Victoria: 50 puntos | Derrota: 10 puntos',
  bp_exp_battle_arena_victory: 'Arena de Batalla: Victoria: 50 puntos | Derrota: 10 puntos',
  bp_exp_league_map_victory: 'Mapa de Liga: Victoria: 55 puntos | Derrota: 10 puntos',
  bp_exp_medusa_victory: 'Medusa: Victoria: 100 puntos | Derrota: 20 puntos',
  bp_exp_roc_victory: 'Roc: Victoria: 100 puntos | Derrota: 20 puntos',
  bp_exp_normal_uniques_victory: 'Unicos Normales: Victoria: 5 puntos | Derrota: 3 puntos',
  bp_exp_arabian_uniques_victory: 'Unicos Árabes: Victoria: 7 puntos | Derrota: 5 puntos',
  bp_exp_legendary_uniques_victory: 'Unicos Legendarios: Victoria: 10 puntos | Derrota: 7 puntos',
  bp_exp_job_kills: 'Asesinatos de Trabajo: 2 puntos por asesinato',
  bp_exp_job_delivery: 'Entrega de Trabajo: 15 puntos por entrega',
  bp_exp_global_chat: 'Uso de Chat Global: 2 puntos por uso de chat global',
  bp_exp_summary:
    'Gana XP del pase en eventos: Tower Defense, Prisión Infernal, Caza de Brujas, Supervivencia, Locura, Jardín, Captura la Bandera, Arena, Liga, Medusa, Roc, Únicos, kills/entregas de job y chat global.',
  silk_confirm_cost: 'Coste: {amount} Silks',
  silk_confirm_balance: 'Tu saldo: {amount} Silks',
  silk_confirm_after: 'Saldo después de la compra: {amount} Silks',
  silk_confirm_not_enough: 'No tienes suficientes Silks para esta compra.',
  silk_confirm_cancel: 'Cancelar',
  silk_confirm_confirm: 'Confirmar',
  bp_premium_confirm_title: 'Comprar Pase Premium',
  bp_premium_confirm_msg: 'Desbloquea todas las recompensas premium de esta temporada.',
  bp_levelup_confirm_title: 'Subir de Nivel',
  bp_levelup_confirm_msg: 'Obtén un nivel del Battle Pass al instante.',
  silk_confirm_price_label: 'Precio',
  silk_confirm_your_silk: 'Tus Silks',
  silk_confirm_checking: 'Verificando...',
  silk_confirm_unavailable: 'No disponible',
  silk_confirm_retry_later: 'Reintentar luego',
  silk_confirm_not_enough_short: 'Silks insuficientes',
  silk_confirm_processing: 'Procesando',
  silk_confirm_processing_msg: 'Procesando tu compra...',
  silk_confirm_success: 'Éxito',
  silk_confirm_failed: 'Falló',
  silk_confirm_wait: 'Espera',
  silk_confirm_close: 'Cerrar',
  cal_schedule_label: 'Periodo: {start} - {end}',
  cal_remaining_label: '({remaining} restante)',
  cal_checked_in_status: 'Registrado {checked} de {total} días ({missed} día(s) perdido(s))',
  cal_day_label: 'Día {day}',
  cal_checkin_available: '¡Puedes hacer check-in ahora!',
  cal_next_checkin: 'Próximo check-in en: {hours}h {minutes}m',
  cal_claim_error: 'No se pudo completar la acción. Inténtalo más tarde.',
  cal_no_campaign: 'Sin campaña activa',
  spin_daily_spins: '{max} Giros Diarios ({used}/{max})',
  spin_recent_rewards: 'Últimas 5 Recompensas',
  spin_congratulations: '¡Felicidades!',
  spin_probability: 'Probabilidad:',
  spin_daily_reached_tooltip: 'Límite diario alcanzado. Para volver a usar, compra con Silk.',
  spin_reset_confirm_title: 'Confirmar Reset',
  spin_reset_confirm_message: '¿Estás seguro de que quieres resetear los giros?',
  spin_reset_confirm_silk: '{amount} silks',
  spin_reset_confirm_cancel: 'Cancelar',
  spin_reset_confirm_confirm: 'Confirmar',
  spin_reset_success: '¡Giros reseteados con éxito!',
  spin_reset_error: 'No se pudieron resetear los giros.',
  spin_error_spin: 'No se pudo girar la ruleta.',
  spin_error_winner: 'Item ganador no encontrado.',
  spin_error_connection: 'Error de conexión con el servidor.',
  so_title: 'Oferta Especial',
  so_recommended: 'Recomendado',
  so_offer_ends_in: 'La oferta termina en',
  so_buy: 'COMPRAR',
  so_available: 'Disponible',
  so_sold_out: 'Agotado',
  so_processing: 'Procesando...',
  so_purchase_success: '¡Compra exitosa!',
  so_purchase_error: 'Error en la compra',
  so_network_error: 'Error de red',
  so_confirm_title: 'Confirmar Compra',
  so_confirm_message: '¿Comprar {name}?',
  so_no_offers: 'No hay ofertas activas',
  auc_time_left: 'Tiempo restante',
  auc_bid_concluded: 'Subasta Concluida',
  auc_winner: 'Ganador',
  auc_auction_starting_soon: 'Subasta comenzando pronto',
  auc_enter_bid: 'Ingresa tu puja',
  auc_bid_now: 'Pujar Ahora',
  auc_be_first_to_bid: 'Sé el primero en pujar',
  auc_current_bid: 'Puja Actual',
  auc_by: 'por',
  auc_latest_bids: 'Últimas pujas',
  auc_auction_ended: 'La subasta ha terminado. ¡Felicitaciones al ganador!',
  auc_wait_next_auction: 'Por favor espera a que comience la próxima subasta.',
  auc_item_rewards: 'Recompensas de Items',
  auc_no_rewards: 'No hay recompensas disponibles',
  auc_bid_success: '¡Puja realizada con éxito!',
  auc_bid_error: 'Error al realizar la puja.',
  auc_invalid_bid: 'Ingresa un monto de puja válido.',
  tm_tab_name: "Name",
  tm_name_colors: "Colores de nombre guardados",
  tm_name_apply: "Aplicar color",
  tm_name_select: "Selecciona un color",
  tm_name_empty: "Aún no tienes colores guardados.",
  tm_name_reuse: "Cada color cuesta 999 Silks. Puedes reutilizar gratis los colores comprados. Espera 30 segundos entre cambios de personalización.",
  tm_name_buy: "Comprar color de nombre",
  tm_name_purchased: "Color de nombre comprado.",
  tm_name_applied: "Color de nombre aplicado.",
  tm_name_owned: "Ya lo tienes",
  tm_name_error: "No se pudo procesar el color.",
  tm_cooldown: "Espera {seconds} segundos antes de otro cambio.",
  tm_tab_title: 'Título',
  tm_tab_icon: 'Icono',
  tm_tab_tag: 'Tag',
  tm_title_column: 'Título',
  tm_tag_column: 'Tag',
  tm_actions_column: 'Acciones',
  tm_enter_title: 'Ingresa el texto del título...',
  tm_enter_tag: 'Ingresa el texto del tag...',
  tm_test: 'Probar',
  tm_edit: 'Editar',
  tm_edit_title_modal_title: 'Editar título',
  tm_price_edit: 'Precio de edición',
  tm_error_editing_title: 'Error al editar el título.',
  tm_title_edited: 'Título actualizado correctamente.',
  tm_buy: 'Comprar',
  tm_total_pay: 'Total a pagar',
  tm_color_optional: 'Color personalizado (opcional)',
  tm_edit_separate: 'Editar un título existente (aparte)',
  tm_price_title: 'Precio del título',
  tm_price_color: 'Precio del color',
  tm_price_tag: 'Precio del tag',
  tm_price_icon_label: '{amount} Silks',
  tm_apply_title: 'Aplicar título',
  tm_remove_title: 'Remover título',
  tm_apply_tag: 'Aplicar tag',
  tm_remove_tag: 'Remover tag',
  tm_no_titles: 'No hay títulos guardados.',
  tm_no_tags: 'No hay tags guardados.',
  tm_no_icons: 'No se encontraron íconos.',
  tm_icon_search: 'Buscar íconos...',
  tm_icon_left: 'Icono izquierdo',
  tm_icon_right: 'Icono derecho',
  tm_buy_title_modal_title: 'Confirmar compra de título',
  tm_buy_tag_modal_title: 'Confirmar compra de tag',
  tm_buy_icon_modal_title: 'Confirmar compra de ícono',
  tm_buy_title_label: 'Título:',
  tm_buy_tag_label: 'Tag:',
  tm_buy_icon_label: 'Ícono:',
  tm_buy_price_label: 'Precio:',
  tm_buy_balance_label: 'Tu saldo:',
  tm_buy_includes: 'Incluye:',
  tm_buy_includes_title_color: 'Título + Color personalizado',
  tm_buy_not_enough: '⚠ No tienes suficientes Silks.',
  tm_buy_needs_more: 'Necesitas {amount} Silks más.',
  tm_buy_confirm: 'Confirmar compra',
  tm_buy_cancel: 'Cancelar',
  tm_error_testing_title: 'Error al probar el título.',
  tm_error_buying_title: 'Error al comprar el título.',
  tm_error_buying_tag: 'Error al comprar el tag.',
  tm_error_buying_icon: 'Error al comprar el ícono.',
  tm_error_applying_icon: 'Error al aplicar el ícono.',
  tm_error_getting_balance: 'Error al obtener el balance de Silk.',
  tm_error_applying_title: 'Error al aplicar el título.',
  tm_error_applying_tag: 'Error al aplicar el tag.',
  tm_error_removing_title: 'Error al remover el título.',
  tm_error_removing_tag: 'Error al remover el tag.',
  tm_processing: 'Procesando...',
  tm_already_have_title: 'Ya tienes este título.',
  tm_already_have_tag: 'Ya tienes este tag.',
  tm_already_have_icon: 'Ya tienes este ícono.',
  tm_not_enough_silk: 'No tienes suficientes Silks.',
  tm_title_applied: 'Título aplicado correctamente.',
  tm_title_purchased: '¡Título comprado! Disfruta tu nuevo título.',
  tm_tag_applied: 'Tag aplicado correctamente.',
  tm_icon_applied: 'Ícono aplicado correctamente.',
  tm_title_removed: 'Título desactivado correctamente.',
  tm_tag_removed: 'Tag removido correctamente.',
  tm_icon_purchased: 'Ícono comprado correctamente.',
  tm_test_applied: 'Vista previa del título aplicada (temporal).',
  ranking_search_placeholder: 'Buscar jugador...',
  ranking_filter_race: 'Raza',
  ranking_race_chinese: 'Chino',
  ranking_race_euro: 'Europeo',
  ranking_filter_mastery: 'Maestría',
  ranking_mastery_bicheon: 'Bicheon',
  ranking_mastery_pacheon: 'Pacheon',
  ranking_mastery_heuksal: 'Heuksal',
  ranking_mastery_warrior: 'Guerrero',
  ranking_mastery_rogue: 'Pícaro',
  ranking_mastery_wizard: 'Mago',
  ranking_filter_reset: 'Restablecer',
  ranking_filter_refresh: 'Actualizar ranking',
  ranking_col_character: 'Personaje',
  ranking_col_guild: 'Guild',
  ranking_col_points: 'Puntos',
  ranking_no_results: 'Ningún jugador coincide con los filtros.',
  ranking_empty: 'El ranking aún no está disponible. Inténtalo más tarde.',
  ranking_error: 'No se pudo cargar el ranking. Pulsa ↺ para reintentar.',
  ranking_error_auth: 'No se pudo cargar el ranking. Pulsa ↺ para reintentar.',
  ranking_player_title: 'Ranking de jugadores',
  ranking_guild_title: 'Ranking de guilds',
  ranking_mastery_title: 'Ranking de maestría',
  ranking_arena_title: 'Ranking Arena PVP',
  ranking_profile_loading: 'Cargando perfil del personaje...',
  ranking_profile_error_title: 'Error',
  ranking_profile_error_message: 'No se pudo cargar el perfil del personaje.',
  ranking_profile_back: 'Volver al ranking',
  ranking_profile_inventory: 'Inventario',
  ranking_profile_avatar: 'Avatar',
  ranking_profile_level: 'Nv.',
  ranking_profile_strength: 'Fuerza:',
  ranking_profile_intelligence: 'Int:',
  ranking_profile_guild: 'Guild:',
  ranking_profile_no_guild: '<none>',
  job_level: 'Nivel',
  job_daily_progress: 'Progreso diario de trabajo',
  job_claimed: 'Reclamado',
  job_completed: 'Completado',
  job_in_progress: 'En progreso',
  job_gold: 'Gold',
  job_min: 'min',
  job_delivery_history: 'Historial de Entregas de Hoy',
  job_route: 'Ruta',
  job_gold_earned: 'Gold Ganado',
  job_delivery_time: 'Tiempo de Entrega',
  job_delivery_hour: 'Hora de Entrega',
  job_no_deliveries_today: 'No hay entregas registradas hoy.',
  job_no_job_info: 'No hay información de trabajo disponible para tu personaje.',
  job_login_required: 'Debes iniciar sesión para ver tu progreso de trabajo.',
  job_hwid_error: 'No se pudo obtener información del hardware.',
  job_level_error: 'No se pudo obtener el nivel de trabajo.',
  job_no_configuration: 'No hay configuración disponible para este tipo de trabajo.',
  job_merchant: 'Comerciante',
  job_thief: 'Ladrón',
  job_hunter: 'Cazador',
  job_unknown: 'Desconocido',
  job_invalid_data: 'Datos inválidos',
  job_already_claimed_today: 'Ya reclamaste la recompensa de hoy.',
  job_complete_progress_first: 'Debes completar el progreso diario antes de reclamar la recompensa.',
  job_no_reward_for_level: 'No hay recompensa disponible para tu nivel actual.',
  job_reward_claimed_success: 'Recompensa reclamada exitosamente.',
  job_success: 'Éxito',
  job_error: 'Error',
  job_network_error: 'Error de red',
  job_protected_cargo: 'Mercancía protegida',
  job_stolen_cargo: 'Mercancía robada',
  cupon_title: 'Cupones',
  cupon_level_required: 'Nivel',
  cupon_rewards_title: 'Recompensas del cupón',
  cupon_expires_in: 'Expira en',
  cupon_claim_button: 'Reclamar Cupón',
  cupon_claimed_button: 'Reclamado',
  cupon_confirm_button: 'Confirmar',
  cupon_resend_button: 'Reenviar código',
  cupon_verification_title: 'Ingresa el código de verificación',
  cupon_choose_channel: 'Donde quieres recibir el codigo?',
  cupon_contact_missing: 'Sin configurar',
  cupon_whatsapp_verify: 'Necesitas un numero verificado',
  cupon_configure_contact: 'Configurar WhatsApp en Ajustes',
  cupon_sent_via: 'Codigo enviado por {channel}',
  cupon_code_sent_info: 'Se enviará un código de verificación a tu correo',
  cupon_code_sent_button: 'Enviado - Revisa tu correo',
  cupon_coupon_claimed: '¡Cupón reclamado exitosamente! Revisa tu cofre en el juego.',
  cupon_no_coupons: 'No hay cupones disponibles en este momento',
  cupon_already_claimed: 'Ya has reclamado este cupón',
  cupon_request_error: 'Error al solicitar el código. Intenta de nuevo.',
  cupon_complete_code: 'Debes ingresar el código completo de 6 dígitos',
  cupon_processing_error: 'Error al procesar la solicitud. Intenta de nuevo.',
  cupon_sending: 'Enviando...',
  cupon_processing: 'Procesando...',
  settings_tab_general: 'General',
  settings_tab_notifications: 'Notificaciones',
  settings_tab_restrictions: 'Restricciones',
  settings_label_language: 'Idioma',
  settings_label_timezone: 'Zona Horaria',
  settings_label_country: 'País',
  settings_label_whatsapp: 'WhatsApp',
  settings_btn_verify: 'Verificar',
  settings_btn_confirm: 'Confirmar',
  settings_btn_save: 'Guardar',
  settings_btn_validate_now: 'Validar Ahora',
  settings_btn_validate_whatsapp: 'Validar por WhatsApp',
  settings_btn_validate_authenticator: 'Validar por Authenticator',
  settings_placeholder_code: 'Código',
  settings_placeholder_phone: '1234567890',
  settings_no_events: 'No hay eventos configurados',
  settings_minutes_before: 'min antes',
  settings_time_remaining: 'Tiempo restante hasta la próxima validación requerida',
  settings_validation_warning: 'Tu validación expirará pronto. Renueva ahora para continuar jugando sin interrupciones.',
  settings_validation_active: 'Tu conexión está validada y activa.',
  settings_validation_expired: 'Debes validar tu conexión para poder moverte en el juego.',
  settings_coming_soon: '(Próximamente)',
  settings_no_hwid: 'No se pudo obtener el HWID. Por favor, inicia sesión en el juego.',
  settings_code_sent: 'Código enviado. Revisa tu WhatsApp.',
  settings_whatsapp_verified_success: 'WhatsApp verificado correctamente',
  settings_error_update_config: 'Error al actualizar configuración',
  settings_error_phone_required: 'Por favor ingresa un número de teléfono',
  settings_error_code_required: 'Por favor ingresa un código válido de 6 dígitos',
  settings_error_send_code: 'Error al enviar código de verificación',
  settings_error_verify_code: 'Error al verificar código',
  settings_error_validate_connection: 'Error al validar conexión',
  settings_error_code_incorrect: 'Código incorrecto',
  settings_no_results: 'No se encontraron resultados',
  settings_searching: 'Buscar...',
  messages_page_title: 'Chat',
  messages_conversations: 'Conversaciones',
  messages_new_chat: 'Nuevo Chat',
  messages_search_player: 'Buscar jugador...',
  messages_type_message: 'Escribe un mensaje...',
  messages_send: 'Enviar',
  messages_attach_item: 'Adjuntar Ítem',
  messages_online: 'En línea',
  messages_offline: 'Desconectado',
  messages_no_messages: 'No hay mensajes aún',
  messages_no_conversations: 'Sin conversaciones',
  messages_loading: 'Cargando...',
  messages_error_send: 'Error al enviar mensaje',
  messages_error_load: 'Error al cargar mensajes',
  messages_retry: 'Reintentar',
  messages_select_player: 'Selecciona un jugador para chatear',
  messages_select_item: 'Seleccionar un ítem',
  messages_item_attached: 'Ítem adjunto',
  messages_remove_item: 'Quitar ítem',
  messages_confirm: 'Confirmar',
  messages_cancel: 'Cancelar',
  messages_today: 'Hoy',
  messages_yesterday: 'Ayer',
  messages_typing: 'escribiendo...',
  messages_translate: 'Traducir',
  messages_show_original: 'Ver original',
  messages_translate_error: 'No se pudo traducir el mensaje',
  messages_scroll_for_more: 'Desplázate arriba para ver mensajes anteriores',

  notifications_title: 'Notificaciones',
  notifications_no_notifications: 'No hay notificaciones disponibles',
  notifications_no_type: 'Sin tipo',
  notifications_published: 'Publicado:',
  notifications_expires: 'Expira:',
  notifications_like: 'Me gusta',
  notifications_dislike: 'No me gusta',
  notifications_back_to_notifications: 'Volver a Notificaciones',
  notifications_vote_error: 'Error al actualizar el voto',
  notifications_loading: 'Cargando...',
  notifications_error_load: 'Error al cargar notificaciones',
  notifications_not_found: 'Notificación no encontrada o no disponible',

  dt_title: 'Tareas Diarias',
  dt_global_progress: 'Progreso Global',
  dt_tasks_completed: 'tareas completadas',
  dt_no_tasks: 'No hay tareas disponibles en este momento.',
  dt_claimed: 'Reclamado',
  dt_incomplete: 'Incompleto',
  dt_final_rewards: 'Recompensas Finales',
  dt_final_rewards_description:
    'Completa todas las tareas diarias y reclama todas sus recompensas para desbloquear estas recompensas finales.',
  dt_claim_final_reward: 'Reclamar Recompensa Final',
  dt_complete_all_first: 'Debes completar y reclamar todas las tareas diarias primero',
  dt_success: 'Éxito',
  dt_error: 'Error',
  dt_network_error: 'Error de red',
  dt_processing: 'Procesando...',
  dt_login_required: 'Debes iniciar sesión para ver tus tareas diarias.',
  dt_load_error: 'No se pudieron cargar las tareas diarias.',

  don_package: 'Paquete:',
  don_silks: 'Silks:',
  don_price: 'Precio:',
  don_silks_label: 'silks',
  don_vip_points: '{amount} Puntos VIP',
  don_promo: 'Promo',
  don_special_offer: 'Oferta especial',
  don_back: '← Atrás',
  don_pay: 'Pagar $',
  don_continue_paypal: 'Continuar a PayPal',
  don_processing: 'Procesando...',
  don_binance_soon: 'Pago con Binance próximamente...',
  don_error_create: 'Error al crear el pago',
  don_stripe_not_loaded: 'Stripe SDK no cargado',
  don_success_processing: 'Procesando pago...',
  don_success_wait: 'Espera mientras confirmamos tu donación.',
  don_success_ok: '¡Pago exitoso!',
  don_success_fail: 'Pago no completado',
  don_success_fail_msg: 'No se pudo confirmar tu donación. Inténtalo de nuevo.',
  don_cancel_title: 'Pago cancelado',
  don_cancel_msg: 'Tu donación no se completó. Puedes intentarlo cuando quieras.',
  don_back_to: 'Volver a Donaciones',
  don_credited: 'Se han acreditado {amount} silks a tu cuenta.',
  cal_claimed: 'Reclamado',
  cal_locked: 'Bloqueado',
  cal_today: 'Hoy',
  cal_claim: 'Reclamar',
  cal_streak_label: 'Días registrados',
  cal_consecutive_login: 'Login consecutivo',
  cal_upcoming: 'Próximas',
  cal_upcoming_rewards: 'Próximas recompensas',
  cal_no_upcoming: 'Sin próximas',
  cal_monthly_bonus: 'Bonus mensual',
  cal_monthly_bonus_desc: 'Regístrate {days} días para reclamar el bonus mensual.',
  cal_days_remaining: '{days} días restantes',
  cal_day_remaining: '1 día restante',
  cal_info_title: 'Información del evento',
  cal_default_desc: 'Inicia sesión cada día para reclamar recompensas exclusivas. ¿Fallaste un día? Sigue adelante, el Imperio te espera.',
  cal_prev: 'Anterior',
  cal_next: 'Siguiente',
  cal_bonus_days_unit: 'días',
  cal_bonus_n_day: '1 día',
  cal_bonus_n_days: '{days} días',
  cal_bonus_7_days: '7 días',
  cal_bonus_15_days: '15 días',
  cal_bonus_1_month: '1 mes',
  bp_multiple_items: 'Múltiples ítems disponibles',
  vip_title: 'Sistema VIP',
  vip_col_level: 'NIVEL',
  vip_col_progress: 'PROGRESO',
  vip_col_rewards: 'RECOMPENSAS',
  vip_col_state: 'ESTADO',
  vip_level_label: 'Nivel VIP ({level})',
  vip_state_unlocked: 'Desbloqueado',
  vip_no_levels: 'No hay niveles VIP configurados.',
  vip_points_rate: '{points} puntos VIP.',
  vip_your_points: 'Tus puntos',
  vip_current_level: 'Nivel actual',
  vip_next_level: 'Siguiente nivel',
  vip_all_unlocked: 'Todos los niveles desbloqueados',
  vip_points_remaining: 'Faltan {points} puntos',
  vip_information: 'Informacion VIP',
  vip_close: 'Cerrar',
  vip_info_account: 'Los puntos VIP pertenecen a tu cuenta. Solo cuentan donaciones completadas con puntos VIP acreditados.',
  vip_info_unlock: 'Alcanza los puntos requeridos para desbloquear cada nivel. Los puntos se acumulan y no se gastan al desbloquearlo.',
  vip_info_rewards: 'Desbloqueado significa que cumples el requisito. La reclamacion y entrega de premios aun no estan disponibles.',
  vip_state_locked: 'Bloqueado',
  vip_note: 'Por cada $1 que dones, recibirás',
  vip_note_points: '10 Puntos VIP.',
  security_cancel_setup: 'Cancelar configuracion',
  security_authenticator: "Autenticador",
  security_whatsapp: "WhatsApp",
  security_email: "Email",
  security_active: "Conexion verificada",
  security_required: "Verifica tu conexion",
  security_duration: "Elige cualquier metodo para desbloquear esta conexion por 24 horas.",
  security_remaining: "Tiempo restante",
  security_methods: "Metodo de verificacion",
  security_ready: "Disponible",
  security_not_configured: "Sin configurar",
  security_unavailable: "La verificacion no esta disponible temporalmente.",
  security_authenticator_help: "Usa un codigo de seis digitos de Google Authenticator, Microsoft Authenticator u otra app compatible.",
  security_whatsapp_help: "Recibe un codigo de un solo uso en tu numero de WhatsApp verificado.",
  security_email_help: "Recibe un codigo de un solo uso en el email registrado en tu cuenta.",
  security_rules: "Cada validacion requiere un codigo nuevo. Los codigos de email y WhatsApp vencen en 10 minutos y permiten 5 intentos. Nunca compartas tus codigos.",
  security_email_missing: "No hay email registrado. Actualiza primero el email de tu cuenta.",
  security_configure_phone: "Configurar numero de WhatsApp",
  security_cancel: "Volver a verificacion",
  security_remove: "Quitar autenticador",
  security_remove_help: "Confirma con tu autenticador, email o WhatsApp verificado. Despues puedes configurar un autenticador nuevo.",
  security_no_connection: "Abre Ajustes desde el juego para verificar esta conexion.",
  security_setup_title: "Configura tu autenticador",
  security_setup_help: "Agrega tu cuenta Republic a la app y confirma con su primer codigo.",
  security_setup: "Configurar autenticador",
  security_qr: "Escanea este QR en tu app autenticadora",
  security_manual_key: "Clave de configuracion manual",
  security_secret_help: "Guarda esta clave en privado. La configuracion vence en 10 minutos.",
  security_phone_label: "Numero de WhatsApp con codigo de pais",
  security_resend: "Reenviar codigo",
  security_send: "Enviar codigo",
  security_code: "Codigo de verificacion de seis digitos",
  security_confirm: "Confirmar configuracion",
  security_validate: "Verificar por 24 horas",
  security_request_error: "No se pudo completar la solicitud. Intenta de nuevo.",
  security_retry: "Reintentar",
  security_general_help: "Configura tu idioma y region. Administra los metodos de verificacion en Restricciones.",
  don_history: 'Historial de compras',
  don_history_loading: 'Cargando compras...',
  don_history_error: 'No se pudo cargar el historial.',
  don_history_empty: 'Todavía no hay compras.',
  don_history_date: 'Fecha',
  don_history_method: 'Método',
  don_history_status: 'Estado',
  don_history_previous: 'Anterior',
  don_history_next: 'Siguiente',
  don_status_completed: 'Completado',
  don_status_pending: 'Pendiente',
  don_status_cancelled: 'Cancelado',
  don_status_failed: 'Fallido',
  don_daily_limit: "Llevas {current} en las últimas 24 horas. Con esta compra de {amount} sumarías {total}, superando el límite de {limit}. Tienes {remaining} disponibles.",
  don_limit_available: "Disponible: {amount}",
  don_reset_ready: "Pagos de las últimas 24 h",
  don_reset_updating: "Actualizando cupo...",
  don_reset_error: "Cupo no disponible",
  don_reset_in: "Se renueva en {time}",
  don_limit_locked: "Alcanzaste el límite de pagos. Espera a que termine la cuenta regresiva del encabezado para volver a pagar.",
} as const;

export default es;
